import { useSetting } from '@/contexts/CompanyContext';
import { mediaUrl } from '@/utils/mediaUtils';
// import {
//   generateQRCodePaymentValue,
//   isValidateQRCode,
// } from '@/utils/qrCodeUtils';
import { QRCode, Space } from 'antd';
import React, { useEffect, useState } from 'react';

interface IProps {
  referenceNo1: string;
  referenceNo2: string;
  customerCode: string;
  ivNo: string;
  amount: number;
  footerTextLeft: string;
  footerTextRight: string;
  paidInfoTemplate: string;
  isNote?: boolean;
  showFooter?: boolean;
  isInvoice?: boolean;
  isReceive?: boolean;
  isTaxInvoice?: boolean;
  isReceipt?: boolean;
  docNo?: string;
  page?: string;
  isMultiPage?: boolean;
  isCndn?: boolean;
  signature?: number;
  isTextReceipt?: boolean;
  driverToken?: string;
}

const TemplateFooter = ({
  footerTextLeft,
  footerTextRight,
  // referenceNo1,
  // referenceNo2,
  isMultiPage = false,
  // customerCode,
  // amount,
  // ivNo,
  paidInfoTemplate,
  isNote,
  showFooter = true,
  isInvoice,
  isReceive = true,
  isTaxInvoice,
  isReceipt,
  docNo,
  page,
  isCndn = false,
  signature,
  isTextReceipt,
  driverToken,
}: IProps) => {
  const [logo, setLogo] = useState<string>('');
  useEffect(() => {
    const fetchLogoUrl = async () => {
      console.log(signature);
      if (signature) {
        const url = await mediaUrl({ id: signature || 0 });
        setLogo(url || '');
      }
    };

    fetchLogoUrl();
  }, [signature]);

  const isPaidInfo = ['TM04', 'TM05', 'TM06', 'TM07'].includes(
    paidInfoTemplate,
  );
  const { setting } = useSetting();

  // const isValidate = isValidateQRCode(
  //   setting?.companyBillerId,
  //   setting?.referenceCode,
  //   customerCode,
  //   ivNo,
  // );
  // const qrCode = generateQRCodePaymentValue(
  //   setting?.companyBillerId,
  //   setting?.referenceCode,
  //   customerCode,
  //   ivNo,
  //   amount || 0,
  // );

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        padding: '20px',
      }}
    >
      {isInvoice && !isMultiPage && (
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          className="text-xs"
          style={{
            width: '100%',
            border: '0.5px black solid',
            borderCollapse: 'collapse',
            marginBottom: 8,
          }}
        >
          <tr>
            <td colSpan={1} style={{ width: '33.33%' }}>
              <div className="pt-3">
                <strong>ผู้รับวางบิล.............................</strong>
              </div>
              <div>วันที่....../....../.........</div>
            </td>
            <td colSpan={1} style={{ width: '33.33%' }}>
              <div className="pt-3">
                <strong>ผู้วางบิล............................</strong>
              </div>
              <div>วันที่....../....../.........</div>
            </td>
            <td colSpan={1} style={{ width: '33.33%' }}>
              <div className="pt-3">
                {logo && (
                  <div className="absolute top-[20px] right-[140px] max-w-[80px]">
                    <img
                      src={logo}
                      alt="pioneerStamp"
                      style={{ maxHeight: 50 }}
                    />
                  </div>
                )}
                <strong>ผู้อนุมัติ.............................</strong>
              </div>
              <div>วันที่....../....../.........</div>
            </td>
          </tr>
          <tr>
            <td colSpan={3} style={{ paddingTop: 10 }}>
              <div>
                <strong>วันที่นัดชำระ.............................</strong>
              </div>
            </td>
          </tr>
        </table>
      )}
      {isTaxInvoice && !isMultiPage && (
        <div className="flex flex-row justify-between w-full text-xs">
          <div className="flex flex-col border border-black rounded w-[340px] p-2">
            <div className="font-bold">
              ได้ตรวจสินค้าและบริการว่าถูกต้องและอยู่ในสภาพสมบรูณ์
            </div>
            <div>
              The goods received as per above in good order and condition
            </div>
            <div className="min-h-[50px]"></div>
            <div className="flex flex-row gap-4">
              <div className="flex flex-col justify-center w-full">
                <div>.....................................................</div>
                <div className="font-bold">ผู้รับสินค้า/Good Received By</div>
              </div>
              <div className="flex flex-col justify-center">
                <div>........./........./...........</div>
                <div className="font-bold">วันที่/Date</div>
              </div>
            </div>
          </div>
          <div className="flex flex-col border border-black rounded w-[285px] p-2">
            <div className="font-bold flex flex-row w-full gap-2">
              <div className="min-w-[40px]">ในนาม</div>
              <div>บริษัท อัลไลด์ อโกร จำกัด</div>
            </div>
            <div className="flex flex-row w-full gap-2">
              <div className="min-w-[40px]">For</div>
              <div>ALLIED AGRO CO., LTD.</div>
            </div>
            <div className="h-full"></div>
            <div className="flex flex-row gap-4 justify-center">
              <div className="flex flex-col justify-center">
                {logo && (
                  <div className="absolute top-[70px] right-[110px] max-w-[100px]">
                    <img
                      src={logo}
                      alt="pioneerStamp"
                      style={{ maxHeight: 100 }}
                    />
                  </div>
                )}
                <div>
                  ..................................................................
                </div>
                <div className="flex justify-center font-bold w-full">
                  ผู้รับมอบอำนาจ/Authorized Signature
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isReceipt && !isMultiPage && (
        <div className="flex flex-row justify-between w-full text-xs">
          <div className="flex flex-col border border-black rounded w-[295px] p-2 items-center justify-end">
            <div className="flex w-full justify-center">
              {logo && !isCndn && (
                <div className="absolute top-[45px] left-[120px] max-w-[100px]">
                  <img
                    src={logo}
                    alt="pioneerStamp"
                    style={{ maxHeight: 100 }}
                  />
                </div>
              )}
              .........................................................
            </div>
            <div className="flex w-full justify-center font-bold">
              {isCndn ? 'ผู้รับวางบิล' : 'ผู้รับเงิน'} / Bill Receiver Signature
            </div>
            <div className="flex w-full justify-center pt-2">
              วันที่ / Date ...........................
            </div>
          </div>
          <div className="flex flex-col border border-black rounded w-[285px] p-2">
            <div className="font-bold flex flex-row w-full gap-2">
              <div className="min-w-[40px]">ในนาม</div>
              <div>บริษัท อัลไลด์ อโกร จำกัด</div>
            </div>
            <div className="flex flex-row w-full gap-2">
              <div className="min-w-[40px]">For</div>
              <div>ALLIED AGRO CO., LTD.</div>
            </div>
            <div className="min-h-[50px]"></div>
            <div className="flex flex-row gap-4 justify-center">
              <div className="flex flex-col justify-center">
                {logo && (
                  <div className="absolute top-[70px] right-[120px] max-w-[100px]">
                    <img
                      src={logo}
                      alt="pioneerStamp"
                      style={{ maxHeight: 100 }}
                    />
                  </div>
                )}
                <div>
                  ......................................................................
                </div>
                <div className="flex justify-center font-bold w-full">
                  ผู้มีอำนาจลงนาม / Authorized Signature
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isReceive && !isMultiPage && (
        <div className="flex w-full text-xs mb-1">
          <table
            border={1}
            cellSpacing={0}
            cellPadding={5}
            style={{
              width: '100%',
              border: '0.5px; black solid',
              borderCollapse: 'collapse',
            }}
          >
            <tr>
              <td colSpan={1}></td>
              <td
                colSpan={1}
                style={{
                  border: '1px solid black',
                  backgroundColor: 'black',
                  color: 'white',
                }}
                width={250}
              >
                <strong>ได้รับสินค้าครบถ้วนสมบูรณ์</strong>
              </td>
              <td colSpan={1} width={250}></td>
            </tr>
            <tr>
              <td colSpan={1}>
                <div className="flex flex-col gap-2 justify-center w-full">
                  <div className="w-full">
                    <Space direction="vertical" align="end">
                      {(driverToken !=
                        '00000000-0000-0000-0000-000000000000' && (
                        <QRCode
                          value={driverToken || docNo || ''}
                          bordered={false}
                          size={70}
                          style={{ textAlign: 'center' }}
                        />
                      )) ||
                        ''}
                    </Space>
                  </div>
                </div>
              </td>
              <td colSpan={1} rowSpan={2} style={{ border: '1px solid black' }}>
                <strong>ผู้รับสินค้า</strong>
                <div style={{ lineHeight: '3em' }}>
                  ..............................................................................
                </div>
                <div>
                  <strong>วันที่ </strong>
                  ......................................................................
                </div>
              </td>
              <td colSpan={1} rowSpan={2} style={{ border: '1px solid black' }}>
                <strong>ผู้ส่งสินค้า</strong>
                <div style={{ lineHeight: '3em' }}>
                  ..............................................................................
                </div>
                <div>
                  <strong>วันที่ </strong>
                  ......................................................................
                </div>
              </td>
            </tr>
            {/* <tr>
              <td colSpan={1} style={{ verticalAlign: 'bottom' }}>
                {isPaidInfo && <strong>กรุณาชำระเงินโดย</strong>}
              </td>
            </tr> */}
          </table>
        </div>
      )}
      {isPaidInfo && !isMultiPage && <strong>กรุณาชำระเงินโดย</strong>}
      {isPaidInfo && !isMultiPage && (
        <div className="flex w-full text-xs mb-2">
          <table
            border={1}
            cellSpacing={0}
            cellPadding={5}
            style={{
              width: '100%',
              border: '0.5px; black solid',
              borderCollapse: 'collapse',
            }}
          >
            <tr>
              <td colSpan={2} style={{ border: '1px solid black' }}>
                <div>
                  กรุณาสั่งจ่ายเช็คขีดคร่อม <strong> (A/C PAYEE ONLY) </strong>
                  ในนาม
                  <strong> “{`${setting?.companyChequeNameTh || ''}`}”</strong>
                </div>
                <div>
                  Please make the cheque <strong> (A/C PAYEE ONLY) </strong>
                  payable to
                  <strong> “{`${setting?.companyChequeNameEn || ''}`}”</strong>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: '1px solid black' }}>
                <div className="flex gap-5">
                  <div>
                    <div>
                      <strong>ชำระผ่านช่องทางโอนเงิน (ทุกธนาคาร)</strong>
                    </div>
                    <div>
                      1. โอนเงินผ่านเข้าธนาคารกสิกรไทย&emsp;ชื่อบัญชี บริษัท
                      อัลไลด์ อโกร จำกัด&emsp;เลขที่บัญชี 228-1-23396-6
                    </div>
                    <div>
                      2. โอนเงินผ่านเข้าธนาคารกรุงเทพ
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ชื่อบัญชี บริษัท
                      อัลไลด์ อโกร จำกัด&emsp;เลขที่บัญชี 114-4-59884-2
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      )}
      {isNote && !isMultiPage && (
        <div
          className="p-2 py-2"
          style={{ border: '1px black solid', minHeight: 100 }}
        >
          <div className="flex justify-between text-2xl font-bold">
            <div>Noted</div>
          </div>
        </div>
      )}
      {showFooter && (
        <div
          className="p-2 py-2"
          style={{ backgroundColor: 'black', color: 'white' }}
        >
          <div className="flex justify-between text-2xl font-bold">
            <div>{footerTextLeft}</div>
            <div>{footerTextRight}</div>
          </div>
        </div>
      )}
      <div className="flex justify-between text-xs">
        <div>
          {isTextReceipt &&
            'ใบเสร็จรับเงินฉบับนี้จะสมบูรณ์ต่อเมื่อบริษัทได้รับเงินเรียบร้อยแล้ว'}
          {page && `หน้า ${page}`}
        </div>
        <div>Document No: {docNo}</div>
      </div>
    </div>
  );
};

export default TemplateFooter;
